import { makeRequest, REQUEST_TYPE } from "./request";
import { KOR_API_PRIVATE } from "../entry";

KOR_API_PRIVATE.dwgSvg = async (props) =>
  makeRequest(props, "dwg/svg", REQUEST_TYPE.POST_FORM_DATA);
